export default __webpack_public_path__ + "static/media/baner1.9c66fe68.png";